import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Information = ({
  tableManager,
  totalCount = tableManager.rowsApi.totalRows,
  pageSize = tableManager.paginationApi.pageSize,
  pageCount = tableManager.paginationApi.pageRows.length,
  selectedCount = tableManager.rowSelectionApi.selectedRowsIds.length
}) => {
  const {
    config: {
      isPaginated,
      tableHasSelection,
      texts: {
        totalRows: totalRowsText,
        rows: rowsText,
        selected: selectedText
      },
      icons: {
        clearSelection: clearSelectionIcon
      },
      additionalProps: {
        information: additionalProps = {}
      }
    },
    paginationApi: {
      page
    },
    rowSelectionApi: {
      setSelectedRowsIds
    }
  } = tableManager;
  let classNames = ('rgt-footer-items-information ' + (additionalProps.className || '')).trim();
  return /*#__PURE__*/_jsxs("div", { ...additionalProps,
    className: classNames,
    children: [totalRowsText, " ", totalCount || 0, "\xA0", !isPaginated ? '' : `| ${rowsText} ${!pageCount ? '0' : `${pageSize * (page - 1) + 1} - ${pageSize * (page - 1) + pageCount}`}`, ' ', tableHasSelection ? /*#__PURE__*/_jsxs(React.Fragment, {
      children: [`| ${selectedCount} ${selectedText}`, selectedCount ? /*#__PURE__*/_jsx("span", {
        className: "rgt-footer-clear-selection-button rgt-clickable",
        onClick: () => setSelectedRowsIds([]),
        children: clearSelectionIcon
      }) : null]
    }) : '']
  });
};

export default Information;